import React from 'react'
import Block from 'layouts/page/Block'
import { ReadView } from '@morningtrain/react-crud'
import Section from 'layouts/page/Section'
import { Model } from '@morningtrain/react-resources'
import { CatchError } from '@morningtrain/react-errors'
import { Can } from '@morningtrain/react-auth'

export default class ReadLayout extends ReadView {
  render () {
    return (
      <Section>
        <Block>
          <Model resourceName={this.resourceName} submittable={false}>
            <CatchError code={404} errorContent={this.renderNotFound.bind(this)}>
              <Can permission={`api.${this.resourceName}.read`}>
                {this.props.children}
              </Can>
            </CatchError>
          </Model>
        </Block>
      </Section>
    )
  }
}
